import {
  ReservationFlowSelectedPaymentMethod,
  ReservationFlowSelectedPaymentMethodNewCreditCard,
} from 'src/interfaces/reservation_flow';

export const isSameSelectedPaymentMethod: (
  selectedPaymentMethod0:
    | ReservationFlowSelectedPaymentMethod
    | ReservationFlowSelectedPaymentMethodNewCreditCard
    | undefined,
  selectedPaymentMethod1:
    | ReservationFlowSelectedPaymentMethod
    | ReservationFlowSelectedPaymentMethodNewCreditCard
    | undefined,
) => boolean = (selectedPaymentMethod0, selectedPaymentMethod1) => {
  if (
    typeof selectedPaymentMethod0 === 'undefined' &&
    typeof selectedPaymentMethod1 === 'undefined'
  ) {
    return true;
  }

  if (
    typeof selectedPaymentMethod0 === 'undefined' ||
    typeof selectedPaymentMethod1 === 'undefined'
  ) {
    return false;
  }

  if (
    selectedPaymentMethod0.type === 'subscription' &&
    selectedPaymentMethod1.type === 'subscription'
  ) {
    return (
      selectedPaymentMethod0.customer_subscription_public_id ===
      selectedPaymentMethod1.customer_subscription_public_id
    );
  }

  if (
    selectedPaymentMethod0.type === 'ticket_book' &&
    selectedPaymentMethod1.type === 'ticket_book'
  ) {
    return (
      selectedPaymentMethod0.product_public_id ===
      selectedPaymentMethod1.product_public_id
    );
  }

  return selectedPaymentMethod0.type === selectedPaymentMethod1.type;
};
